
import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Utils } from "oweb";
import { Component, Vue, Watch, Emit, Prop } from "vue-property-decorator";

let field_id = 0;
const markField = (field: any) => {
	let id =
		field.attrs && field.attrs.id
			? field.attrs.id
			: `ow-field-id-${++field_id}`;

	if (field.label) {
		let attrs = field.label.attrs;
		field.label.attrs = attrs ? { ...attrs, for: id } : { for: id };
	}

	let attrs = field.attrs;
	field.attrs = attrs ? { ...attrs, id } : { id };

	return field;
};

@Component
export default class WField extends BaseComponent {
	@Prop({ type: Object, required: true })
	readonly options: any;

	@Prop({ default: "" })
	readonly value: any;

	@Prop({ type: Boolean, default: false })
	readonly checked!: boolean;

	hasValue = false;
	isValidated = false;
	isValid = false;

	// Synchronize changes of value props
	@Watch("value")
	watchValue(nVal: any, oVal: any) {
		let $field = $(this.$refs.field);

		if (nVal !== oVal) {
			$field.val(nVal);
		}
	}

	// Synchronize changes of checked props
	@Watch("checked")
	watchChecked(val: any) {
		let f: any = this.$refs.field;
		if (this.shouldUseCheckedAttr()) {
			let v = !!val;
			if (f.checked !== v) {
				f.checked = v;
			}
		}
	}

	shouldUseCheckedAttr() {
		return ~["checkbox", "radio"].indexOf(this.options.field);
	}
	canAutoValidate() {
		return !~["checkbox", "radio", "button"].indexOf(this.options.field);
	}

	$_autoValidate(onmount: boolean = false) {
		let x = this;

		if (!x.canAutoValidate()) {
			return;
		}

		let $field = $(this.$refs.field),
			val = $field.val(),
			hasOwn = Object.prototype.hasOwnProperty;

		if (typeof val === "number") {
			this.hasValue = true;
		} else if (val && (!hasOwn.call(val, "length") || val.length)) {
			this.hasValue = true;
		} else {
			this.hasValue = false;
		}

		if (onmount) {
			return;
		}

		let form = <HTMLFormElement>$field.parents("form").get(0);

		if (!form) return;

		let name = <string>$field.attr("name"),
			o = app.getFormValidator(form, [name], [], true),
			valid = true;

		if (!o.validate()) {
			let errors = o.getErrors();
			if (errors[name] && errors[name].length) {
				console.error("fields error", errors);
				valid = false;
			}
		}

		this.isValidated = true;
		this.isValid = valid;
	}

	$_events() {
		let x = this;

		$(x.$refs.field)
			.off(".ow_field")
			.on("change.ow_field", evt => {
				x.onChange(evt);
			})
			.on("input.ow_field", evt => {
				x.onInput(evt);
			})
			.on("focus.ow_field", evt => {
				x.onFocus(evt);
			})
			.on("blur.ow_field", evt => {
				x.onBlur(evt);
			});
	}

	@Emit("change")
	onChange(e: any) {
		this.$_autoValidate();
	}

	@Emit("blur")
	onBlur(e: any) {}

	@Emit("focus")
	onFocus(e: any) {}

	@Emit("input")
	onInput(e: any) {
		// to comply with v-model mechanism
		return e.target.value;
	}

	mounted() {
		this.$_events();

		if (this.shouldUseCheckedAttr()) {
			this.checked && $(this.$refs.field).attr("checked", 1);
		} else {
			this.value && $(this.$refs.field).val(this.value);
		}
		// first run
		this.$_autoValidate(true);
	}

	created() {
		markField(this.options);
	}
}
